import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

import store from '../store';
import routes from './routes';

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	linkActiveClass: 'is-active',
	routes,
});

router.beforeEach((to, from, next) => {
	// reset title
	document.title = 'Minlæring - Administration';

	if (!store.getters['auth/isAuthenticated'] && to.meta.public !== true) {
		next({ name: 'login', query: { redirect: to.fullPath } });
		return;
	} else if (store.getters['auth/isAuthenticated'] && to.meta.public === true) {
		next({ name: 'home' });
		return;
	}

	store.dispatch('router/storeRoute', { route: to });

	const requests = [];

	if (store.getters['auth/isAuthenticated']) {
		// If we are authenticated but don't have a user in store - get the user.
		// A copy cached before is_admin existed cannot answer the CRM check below,
		// so it is fetched again rather than read as an editor.
		if (store.state.user.user === null || store.state.user.user.is_admin === undefined) {
			requests.push(store.dispatch('user/getUser'));
		}
		// Always keep courses loaded
		if (store.state.courses.courses.length === 0) {
			requests.push(store.dispatch('courses/getCourses'));
		}
		// Always keep tooltips loaded
		if (store.state.tooltips.tooltips.length === 0) {
			requests.push(store.dispatch('tooltips/getTooltips'));
		}

		// Always keep languages loaded
		if (store.state.languages.languages.length === 0) {
			requests.push(store.dispatch('languages/getLanguages'));
		}

		// Check if we already have a Lix token
		if (!store.getters['lix/isAuthenticated']) {
			requests.push(store.dispatch('lix/getToken'));
		}
	}

	// Where this navigation really ends up, decided once the user is loaded: an
	// editor is told a CRM route is not there rather than shown a page of errors,
	// and starts on the books listing, the dashboard holding nothing but CRM for
	// them. Undefined lets the navigation through as it is.
	const destination = () => {
		if (store.getters['user/isAdmin']) {
			return undefined;
		}

		if (to.matched.some(route => route.meta.admin)) {
			return { name: 'not-found' };
		}

		return to.name === 'home' ? { name: 'books.index' } : undefined;
	};

	if (requests.length === 0) {
		next(destination());
		return;
	}

	Promise.all(requests)
		.then(() => next(destination()))
		.catch(err => next(err));
});

export default router;
